import { render } from "./DefinitionList.vue?vue&type=template&id=a5ad2360"
import script from "./DefinitionList.vue?vue&type=script&lang=js"
export * from "./DefinitionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__